@let forbiddenMessage = 'general.forbidden_action' | translate;

<div [formGroup]="form">
  <div
    class="pdf-settings__pdf-export"
    [class.pdf-settings__pdf-export--stacked]="showStacked()"
  >
    <wilson-form-field
      [label]="'invoice_pdf_settings_form.pdf_export.label' | translate"
    >
      <nz-select
        nzMode="multiple"
        formControlName="invoicePdfTypes"
        nz-tooltip
        [nzTooltipTitle]="!editable() ? forbiddenMessage : ''"
      >
        @for (pdfType of iterablePdfTypes; track pdfType) {
          <nz-option
            [nzValue]="pdfType[1]"
            [nzLabel]="
              'invoice_pdf_settings_form.pdf_export.option.' + pdfType[0]
                | translate
            "
          />
        }
      </nz-select>
    </wilson-form-field>
  </div>

  @if (attachmentSelected()) {
    @if (showAttachmentLegend()) {
      <h6>
        {{
          'page.settings.company_settings.invoice_settings.attachment_type.header'
            | translate
        }}
      </h6>
      <p class="pdf-settings__description">
        {{
          'page.settings.company_settings.invoice_settings.attachment_type.description'
            | translate
        }}
      </p>
    }
    <div
      class="pdf-settings__row"
      [class.pdf-settings__row--stacked]="showStacked()"
    >
      <wilson-form-field
        [label]="
          'invoice_pdf_settings_form.attachment_grouping.label' | translate
        "
      >
        <nz-select
          formControlName="attachmentGrouping"
          nz-tooltip
          [nzTooltipTitle]="!editable() ? forbiddenMessage : ''"
        >
          @for (groupingType of iterableGroupingTypes; track groupingType) {
            <nz-option
              [nzValue]="groupingType[1]"
              [nzLabel]="
                'invoice_pdf_settings_form.attachment_grouping.option.' +
                  groupingType[0] | translate
              "
            />
          }
        </nz-select>
      </wilson-form-field>

      @if (
        groupingValue() ===
        BillingFormAttachmentGroupingType.GROUPED_BY_ACTIVITY
      ) {
        <wilson-form-field
          [label]="
            'invoice_pdf_settings_form.attachment_activity_info.label'
              | translate
          "
        >
          <nz-select
            formControlName="attachmentActivityInfo"
            nz-tooltip
            [nzTooltipTitle]="!editable() ? forbiddenMessage : ''"
          >
            @for (
              activityInfoType of iterableActivityInfoTypes;
              track activityInfoType
            ) {
              <nz-option
                [nzValue]="activityInfoType[1]"
                [nzLabel]="
                  'invoice_pdf_settings_form.attachment_activity_info.option.' +
                    activityInfoType[0] | translate
                "
              />
            }
          </nz-select>
        </wilson-form-field>
      } @else if (
        groupingValue() !== BillingFormAttachmentGroupingType.GROUPED_BY_SHIFT
      ) {
        <wilson-form-field
          [label]="
            'invoice_pdf_settings_form.attachment_shift_info.label' | translate
          "
        >
          <nz-select
            formControlName="attachmentShiftInfo"
            nz-tooltip
            [nzTooltipTitle]="!editable() ? forbiddenMessage : ''"
          >
            @for (
              shiftInfoType of iterableShiftInfoTypes;
              track shiftInfoType
            ) {
              <nz-option
                [nzValue]="shiftInfoType[1]"
                [nzLabel]="
                  'invoice_pdf_settings_form.attachment_shift_info.option.' +
                    shiftInfoType[0] | translate
                "
              />
            }
          </nz-select>
        </wilson-form-field>
      }
    </div>
  }
</div>
